import { HomeComponent } from './../home/home.component';
import { Router } from '@angular/router';
import { Component } from '@angular/core';
import { MatDialog } from '@angular/material';
import { GLOBAL } from 'src/app/services/global';
@Component({
  selector: "page-auxUrl",
  templateUrl: "auxUrl.component.html",
  styleUrls: ["./auxUrl.component.css"]
})

export class AuxUrlComponent {
  public filedomSeguimientoUrl = GLOBAL.filedomSeguimientoUrl;
  public acotado = GLOBAL.acotado;
  public nombreMuni = GLOBAL.nombreMuni;

  constructor(private dialog: MatDialog, private _router: Router) {

  }
  sign(tipo) {
    //  alert(tipo);
    if (sessionStorage.getItem("identity-domCloud") && sessionStorage.getItem("token-domCloud")) {
      this.dialog.closeAll();


      if (tipo == 'expediente') {
        // console.log("expediente 1");
        this._router.navigate([`/expedientes`]);
      } else if (tipo == 'seguimiento_expediente') {
        // console.log("seguimiento expediente 1");
        this._router.navigate([`/seguimiento-expediente`]);

      } else if (tipo == 'seguimiento_expediente2') {
        console.log("seguimiento expediente 2");
        //window.open(`${GLOBAL.seguimientoSolicitudes}`, "_blank")
        this._router.navigate([`/seguimiento-expediente`]);
      }

      else if (tipo == 'validar-doc') {
        console.log("validar-doc");
        //window.open(`${GLOBAL.seguimientoSolicitudes}`, "_blank")
        this._router.navigate([`/validar-documento`]);
      }
      //  


    } else {
      if (tipo == 'expediente') {
        //console.log("expediente 2");
        localStorage.setItem("navdomcloud", 'expedientes')
        this.dialog.closeAll();
        this.dialog.open(HomeComponent, {
          data: {
            url: 'expedientes'
          }
        })
      } else if (tipo == 'seguimiento_expediente') {
        // console.log("seguimiento expediente 2");
        localStorage.setItem("navdomcloud", 'seguimiento_expediente')
        // window.open(`${GLOBAL.seguimientoSolicitudes}`, "_blank")
        this._router.navigate([`/seguimiento-expediente`]);

      } else if (tipo == 'seguimiento_expediente2') {
        console.log("seguimiento expediente 2b");
        this.dialog.closeAll();
        this._router.navigate([`/seguimiento-expediente`]);

      }
      else if (tipo == 'validar-doc') {
        console.log("validar-doc");
        this.dialog.closeAll();
        //window.open(`${GLOBAL.seguimientoSolicitudes}`, "_blank")
        this._router.navigate([`/validar-documento`]);
      }
    }
  }
}
